import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
    {
      path: '/',
      name: 'home',
        component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
        meta: {
            title: '首页',
            isLogin: true
        }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import( /* webpackChunkName: "about" */ './views/user/auth.vue'),
        meta: {
            title: '登录授权',
            isLogin: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import( /* webpackChunkName: "about" */ './views/user/login.vue'),
        meta: {
            title: '店铺申请',
            isLogin: false
        }
    },
    {
        path: '/apply',
        name: 'Apply',
        component: () => import( /* webpackChunkName: "about" */ '@/views/user/apply'),
        meta: {
            title: '店铺申请',
            isLogin: false
        }
    },
    {
        path: '/apply_success',
        name: 'Apply',
        component: () => import( /* webpackChunkName: "about" */ '@/views/user/apply_success.vue'),
        meta: {
            title: '等待审核',
            isLogin: false
        }
    },
    {
        path: '/apply1',
        name: 'Apply1',
        component: () => import( /* webpackChunkName: "about" */ '@/views/user/apply1'),
        meta: {
            title: '店铺申请',
            isLogin: false
        }
    },
    {
        path: '/shop',
        name: 'Shop',
        component: () => import( /* webpackChunkName: "about" */ '@/views/shop/index.vue'),
        meta: {
            title: '店铺管理',
            isLogin: false
        }
    },
    {
        path: '/food',
        name: 'Food',
        component: () => import( /* webpackChunkName: "about" */ '@/views/food/index'),
        meta: {
            title: '菜品管理',
            isLogin: false
        }
    },
    {
        path: '/out_order',
        name: 'OutOrder',
        component: () => import('@/views/order/out'),
        meta: {
            title: '外卖订单',
            isLogin: false
        }
    },
    {
        path: '/out_show',
        name: 'OutShow',
        component: () => import('@/views/order/out_show'),
        meta: {
            title: '订单详情',
            isLogin: false
        }
    },
    {
        path: '/order',
        name: 'Order',
        component: () => import('@/views/order/index'),
        meta: {
            title: '堂食订单',
            isLogin: false
        }
    },
    {
        path: '/report',
        name: 'Report',
        component: () => import('@/views/shop/report'),
        meta: {
            title: '资金报表',
            isLogin: false
        }
    },
    {
        path: '/tool_profit',
        name: 'Profit',
        component: () => import('@/views/tool/profit'),
        meta: {
            title: '净利润计算器',
            isLogin: false
        }
    }
  ]

export const createRouter = (routes = []) => new VueRouter({
    mode: 'history',
    base: '',
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

const router = createRouter(routes)

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

router.$addRoutes = (params) => {
  // router.matcher  = createRouter(routes).matcher
  // router.options.routes  =  routes
  router.addRoutes(params)

}

export default router
